export const TABS = { TIERS: 0, PAYMENT: 1 }
